import { LockIcon } from '@orn/shared-web/icons';

import type { AssistantMembershipPause } from '../../hooks/assistant/useAssistantMembershipPause';

const PLACEHOLDER_BY_PAUSE_KIND: Record<AssistantMembershipPause['kind'], string> = {
  lapsed: 'Chat is paused until you restart',
  neverStarted: 'Chat is paused until your membership starts',
  unknown: 'Chat is paused until your membership is active',
};

interface IAssistantPausedComposerProps {
  pause: AssistantMembershipPause;
}

/**
 * Stand-in for the composer while the assistant is paused: a disabled field
 * that says why, so the input region keeps its place without accepting a turn.
 */
const AssistantPausedComposer = ({ pause }: IAssistantPausedComposerProps) => (
  <div className="bg-secondary border-primary flex items-center gap-2 rounded-2xl border border-dashed py-1.5 pl-4 pr-1.5">
    <label htmlFor="assistant-paused-input" className="sr-only">
      Message the assistant
    </label>
    <input
      id="assistant-paused-input"
      disabled
      placeholder={PLACEHOLDER_BY_PAUSE_KIND[pause.kind]}
      className="placeholder:text-tertiary text-reg h-10 min-w-0 flex-1 cursor-not-allowed bg-transparent outline-none"
    />
    <button
      type="button"
      disabled
      aria-label="Send (unavailable)"
      className="bg-disabled text-disabled flex size-10 shrink-0 cursor-not-allowed items-center justify-center rounded-xl"
    >
      <LockIcon aria-hidden="true" className="size-4" />
    </button>
  </div>
);

export default AssistantPausedComposer;
